// examples: July 6, 2024
const getLongMonthDayYear = (dateStr: string) => {
  const date = new Date(dateStr);

  if (date.toString() === 'Invalid Date') return undefined;

  const day = date.getDate();
  const month = date.toLocaleString('default', { month: 'long' });
  const year = date.getFullYear();

  return `${month} ${day}, ${year}`;
};

export default getLongMonthDayYear;
